import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

export default function AppHeader({ showJournalCount, journalCount = 0 }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <header className="app-header" data-testid="app-header">
      <Link to={user ? "/app" : "/"} className="brand-mark" data-testid="brand-link">
        <span className="num">111</span>
        <span>Collective</span>
      </Link>

      <nav className="nav-row">
        {user ? (
          <>
            <Link
              to="/app"
              className={`nav-link ${location.pathname === "/app" ? "active" : ""}`}
              data-testid="nav-home"
            >
              Today
            </Link>
            <Link
              to="/journal"
              className={`nav-link ${location.pathname === "/journal" ? "active" : ""}`}
              data-testid="nav-journal"
            >
              {showJournalCount ? `Journal · ${journalCount}` : "Journal"}
            </Link>
            <Link
              to="/upgrade"
              className={`nav-link ${location.pathname === "/upgrade" ? "active" : ""}`}
              data-testid="nav-upgrade"
            >
              {user.subscription_status === "active" ? "Account" : "Upgrade"}
            </Link>
            <button onClick={handleLogout} className="nav-link" data-testid="nav-logout">
              Sign out
            </button>
          </>
        ) : (
          <>
            <Link to="/login" className="nav-link" data-testid="nav-login">Sign in</Link>
            <Link to="/register" className="nav-link pill" data-testid="nav-register">Begin</Link>
          </>
        )}
      </nav>
    </header>
  );
}
